"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const StyledFeatherIcon_1 = require("components/Dashboard/NavigationSidebar/StyledFeatherIcon");
const config_1 = require("assets/styles/config");
const StyledHover_1 = require("components/Dashboard/StyledHover");
const Toast_1 = __importDefault(require("components/general/Toast/Toast"));
const useToast_1 = __importDefault(require("components/general/Toast/useToast"));
const SensitiveData = ({ data, navigator = window.navigator }) => {
    const bullet = '•';
    const [isVisible, setIsVisible] = (0, react_1.useState)(false);
    const { toastParams, setToastMessage } = (0, useToast_1.default)();
    function toggleVisibility() {
        setIsVisible((visible) => !visible);
    }
    function copyToClipboard() {
        return __awaiter(this, void 0, void 0, function* () {
            yield navigator.clipboard.writeText(data);
            setToastMessage('Copied');
        });
    }
    const visibleStyles = {
        padding: '4px',
        background: 'white',
        borderRadius: '4px',
        boxShadow: '#16151d1a 0 2px 4px 0',
        filter: 'drop-shadow(0 0 0.1rem #e4e8ee)'
    };
    return (react_1.default.createElement("span", { className: '', style: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            paddingLeft: 0,
            position: 'relative'
        } },
        react_1.default.createElement(Toast_1.default, Object.assign({}, toastParams)),
        react_1.default.createElement("span", { style: Object.assign({ position: 'absolute', display: 'flex', alignItems: 'center' }, (isVisible ? visibleStyles : {})) },
            react_1.default.createElement("span", { style: {
                    fontFamily: 'monospace',
                    minWidth: isVisible ? '250px' : '100px',
                    overflow: isVisible ? '' : 'hidden'
                } }, isVisible ? data : new Array(10).fill('').map(() => bullet)),
            react_1.default.createElement("span", { style: { marginLeft: '12px', color: config_1.colors.blurple } },
                react_1.default.createElement(StyledHover_1.StyledHover, { hoverColor: config_1.colors.indigo, pointer: true },
                    react_1.default.createElement(StyledFeatherIcon_1.StyledFeatherIcon, { className: `fe ${isVisible ? 'fe-eye-off' : 'fe-eye'} sensitive-data-toggle`, "data-id": 'toggle-visibility', 
                        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                        margin: '8px', onClick: toggleVisibility })),
                react_1.default.createElement(StyledHover_1.StyledHover, { hoverColor: config_1.colors.indigo, pointer: true },
                    react_1.default.createElement(StyledFeatherIcon_1.StyledFeatherIcon, { className: 'fe fe-copy', "data-id": 'copy-data', 
                        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                        margin: '8px', onClick: copyToClipboard }))))));
};
SensitiveData.propTypes = {
    data: prop_types_1.default.string,
    navigator: prop_types_1.default.shape({
        clipboard: prop_types_1.default.shape({
            writeText: prop_types_1.default.func
        })
    })
};
exports.default = SensitiveData;
